---
id: github-actions-generator
title: GitHub Actions Workflow Generator
category: cicd
difficulty: beginner
tags:
  - github-actions
  - workflow
  - generator
  - yaml
  - automation
description: >
  Generates a complete GitHub Actions workflow file based on project
  requirements and best practices.
whenToUse: >
  When setting up a new CI/CD pipeline or migrating from another CI
  system to GitHub Actions.
variables:
  - name: language
    desc: Programming language (Node.js, Python, Go, etc.)
  - name: build_tool
    desc: Build tool (npm, gradle, make, etc.)
  - name: test_framework
    desc: Test framework (jest, pytest, go test, etc.)
  - name: deploy_target
    desc: Where to deploy (AWS, Azure, GCP, K8s, static hosting)
  - name: branch_strategy
    desc: Branch strategy (trunk-based, gitflow, etc.)
  - name: requirements
    desc: Additional requirements (linting, coverage thresholds, etc.)
tips:
  - Start with a minimal workflow and iterate — avoid over-engineering on day one.
  - Always use concurrency groups to cancel outdated PR runs.
  - Pin actions to commit SHAs, not tags, for supply chain security.
---

You are a GitHub Actions expert. Generate a production-ready workflow file.

## Project Details
- Language/Framework: {{language}}
- Build tool: {{build_tool}}
- Test framework: {{test_framework}}
- Deployment target: {{deploy_target}}
- Branch strategy: {{branch_strategy}}

## Requirements
{{requirements}}

## Task
Generate a complete .github/workflows/ci.yml that includes:
1. Appropriate triggers (push, PR, schedule if needed)
2. Build and test jobs with proper caching
3. Security scanning step
4. Deployment job (if deploy_target specified)
5. Proper secret handling
6. Concurrency control to prevent duplicate runs
7. Status badges instruction

Follow these best practices:
- Pin action versions to full SHA
- Use OIDC for cloud auth where possible
- Add timeout-minutes to all jobs
- Use job-level permissions (least privilege)

Respond with the complete YAML file and a brief explanation of each section.

<!-- EXAMPLE_OUTPUT -->

# See full workflow YAML with:
# - push/PR triggers with path filters
# - Concurrency group to cancel stale runs
# - Build job with Node 20, npm caching
# - Test job with coverage threshold
# - Deploy job gated on main branch
# - All actions pinned to SHA
